import { createReducer } from 'utils/redux';

const SHOW_LOADING = 'loading/SHOW_LOADING';
const HIDE_LOADING = 'loading/HIDE_LOADING';

/*
loadingURLs is an object instead of an array because we could have duplicate
urls, and if we got a hideLoading call we don't want to remove all the ocurrence
for that url, just the first one (in this case could be remove or decrease the number),
and that is expensive because I need to iterate the array. Using an object it is
really fast to access or remove a URL.

Example:

loadingURLs = {
  influencer-1': {
    count: 1,
    block: true // this attribute will appear in the future
  }
}
*/

const initialState = {
  isVisible: false,
  loadingURLs: {} // this is necessary here just for debug purpose
};

export function hideLoading(url) {
  return {
    type: HIDE_LOADING,
    payload: {
      url
    }
  };
}

export function showLoading(url) {
  return {
    type: SHOW_LOADING,
    payload: {
      url
    }
  };
}

export default createReducer('loading', initialState, {
  [SHOW_LOADING]: (state, { url }) => {
    // cloning the object for debugin purpose
    let newLoadingURLs = { ...state.loadingURLs };

    if (newLoadingURLs[url] !== undefined) {
      const count = newLoadingURLs[url];

      newLoadingURLs = {
        ...newLoadingURLs,
        [url]: count + 1
      };
    } else {
      newLoadingURLs = {
        ...newLoadingURLs,
        [url]: 1
      };
    }

    // If for that URL we are already showing the loading I will not force to
    // render again because it's unnecessary
    if (Object.keys(newLoadingURLs).length !== 1) {
      return {
        ...state,
        loadingURLs: newLoadingURLs
      };
    }

    return {
      ...state,
      isVisible: true,
      loadingURLs: newLoadingURLs
    };
  },

  [HIDE_LOADING]: (state, { url }) => {
    // could be the case where we forgot to show the loading and we are trying to
    // hide the loading, so in this case we return the state.
    if (!state.loadingURLs[url]) {
      return state;
    }

    // cloning the object for debugin purpose
    let newLoadingURLs = { ...state.loadingURLs };
    const count = newLoadingURLs[url];

    if (count > 1) {
      newLoadingURLs = {
        ...newLoadingURLs,
        [url]: count - 1
      };
    } else {
      const copyNewLoadingURLs = {};
      // Delete is not working for mutate states so this is just to remove one key
      Object.keys(newLoadingURLs).forEach(u => {
        if (u !== url) {
          copyNewLoadingURLs[u] = newLoadingURLs[u];
        }
      });
      newLoadingURLs = { ...copyNewLoadingURLs };
    }

    // if after hide_loading for an URL we still have entries on loadingURLs
    // it's not necessary to force a reloading
    if (Object.keys(newLoadingURLs).length !== 0) {
      return {
        ...state,
        loadingURLs: newLoadingURLs
      };
    }

    return {
      ...state,
      isVisible: false,
      loadingURLs: newLoadingURLs
    };
  }
});
